import { cloneDeep } from "lodash";

const DEFAULT_ATTRIBUTES = {
  order_id: "",
  created_at: null,
  completed_at: null,
  received_at: null,
  updated_at: null,
  processing_at: null,
  quality: false,
  order: null,
  status: "",
  scheduled_action: "",
  action_resource: null,
};

export class CheckIn {
  constructor(attributes) {
    const attrs = { ...cloneDeep(DEFAULT_ATTRIBUTES), ...attributes };

    Object.keys(attrs).forEach((key) => {
      this[key] = attrs[key];
    });
  }

  //? scheduled_action methods
  get actionStock() {
    return this.scheduled_action === "stock";
  }

  get actionReturn() {
    return this.scheduled_action === "return";
  }

  get actionResend() {
    return this.scheduled_action === "resend";
  }

  get actionPickup() {
    return this.scheduled_action === "pickup";
  }

  get isProcessed() {
    return !!this.received_at;
  }
}
